import React from "react";
import { Box, Typography } from "@mui/material";

export type TrendChartZoneLabelBand = {
  x: number;
  y: number;
  /** Localized zone label (caller runs `t(...)`) */
  label: string;
  color: string;
};

type TrendChartZoneLabelBandsProps = {
  chartRightMargin: number;
  chartHeight: number;
  yMargin: { top: number; bottom: number };
  yDomain: [number, number];
  bandCenters: TrendChartZoneLabelBand[];
};

/**
 * Right-hand zone labels for three-band exercise/sleep style charts.
 */
export function TrendChartZoneLabelBands({
  chartRightMargin,
  chartHeight,
  yMargin,
  yDomain,
  bandCenters,
}: TrendChartZoneLabelBandsProps) {
  const plotHeight = chartHeight - yMargin.top - yMargin.bottom;
  const ySpan = yDomain[1] - yDomain[0];
  const yToTop = (y: number) =>
    yMargin.top + plotHeight * (1 - (y - yDomain[0]) / ySpan);

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: `calc(100% - ${chartRightMargin}px)`,
        width: chartRightMargin,
        pointerEvents: "none",
        zIndex: 1,
      }}
    >
      {bandCenters.map(({ x, y, label, color }, index) => (
        <Box
          key={`${index}-${x}-${y}`}
          sx={{
            position: "absolute",
            left: x,
            right: 0,
            top: yToTop(y) - 6,
            height: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Typography
            component="span"
            sx={{
              fontSize: 10,
              fontWeight: 700,
              color,
            }}
          >
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
